export default __webpack_public_path__ + "static/media/13.5678f1a1.jpg";